/**
 * Sync Shopify cookie-banner consent with Microsoft Clarity (and
 * clear leftover analytics cookies when analytics is not allowed).
 *
 * Boot this file as a blocking script BEFORE {{ content_for_header }}
 * so Clarity is queued in denied mode before the app embed loads.
 * Call window.__themeConsent.sync() AFTER content_for_header.
 */
(function (window, document) {
  if (window.__themeConsent) return;

  window.clarity =
    window.clarity ||
    function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };

  var ANALYTICS_PREFIXES = ['_clck', '_clsk', '_cs_', '_tccl_', '_ga', '_gid', '_gat'];

  function cookieDomains() {
    var host = window.location.hostname;
    var root = host.replace(/^www\./, '');
    var domains = ['', host, '.' + host];
    if (root !== host) {
      domains.push(root, '.' + root);
    }
    return domains;
  }

  function deleteCookie(name) {
    cookieDomains().forEach(function (domain) {
      var base =
        name + '=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      document.cookie = domain ? base + '; domain=' + domain : base;
    });
  }

  function deleteAnalyticsCookies() {
    document.cookie.split(';').forEach(function (part) {
      var name = part.split('=')[0].trim();
      if (!name) return;
      var match = ANALYTICS_PREFIXES.some(function (prefix) {
        return name === prefix || name.indexOf(prefix) === 0;
      });
      if (match) deleteCookie(name);
    });
  }

  function signalClarity(analyticsAllowed, marketingAllowed) {
    if (typeof window.clarity !== 'function') return;
    try {
      window.clarity('consentv2', {
        ad_Storage: marketingAllowed ? 'granted' : 'denied',
        analytics_Storage: analyticsAllowed ? 'granted' : 'denied',
      });
    } catch (error) {
      /* Clarity may not have installed yet; the queued stub still holds the call. */
    }
  }

  var lastAnalytics = false;
  var lastMarketing = false;
  var clearTimers = [];
  var syncStarted = false;

  function stopClearRetries() {
    clearTimers.forEach(function (id) {
      window.clearTimeout(id);
    });
    clearTimers = [];
  }

  function scheduleClearRetries() {
    stopClearRetries();
    [0, 300, 1000, 3000, 8000].forEach(function (delay) {
      clearTimers.push(
        window.setTimeout(function () {
          if (lastAnalytics) return;
          signalClarity(false, lastMarketing);
          deleteAnalyticsCookies();
        }, delay)
      );
    });
  }

  function apply(analyticsAllowed, marketingAllowed) {
    lastAnalytics = !!analyticsAllowed;
    lastMarketing = !!marketingAllowed;
    signalClarity(lastAnalytics, lastMarketing);
    if (!lastAnalytics) {
      deleteAnalyticsCookies();
      scheduleClearRetries();
      return;
    }
    stopClearRetries();
  }

  apply(false, false);

  function readShopifyConsent() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return null;

    try {
      return {
        analytics:
          typeof privacy.analyticsProcessingAllowed === 'function'
            ? !!privacy.analyticsProcessingAllowed()
            : false,
        marketing:
          typeof privacy.marketingAllowed === 'function'
            ? !!privacy.marketingAllowed()
            : false,
      };
    } catch (error) {
      return { analytics: false, marketing: false };
    }
  }

  function applyFromShopify(detail) {
    if (detail && typeof detail.analyticsAllowed === 'boolean') {
      apply(detail.analyticsAllowed, !!detail.marketingAllowed);
      return;
    }
    var consent = readShopifyConsent();
    if (consent) apply(consent.analytics, consent.marketing);
  }

  function loadPrivacyApi(callback) {
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        callback
      );
      return;
    }
    callback(new Error('Shopify privacy API unavailable'));
  }

  function sync() {
    if (syncStarted) return;
    syncStarted = true;

    applyFromShopify();

    loadPrivacyApi(function (error) {
      if (!error) applyFromShopify();
    });

    document.addEventListener('visitorConsentCollected', function (event) {
      applyFromShopify(event.detail);
    });
  }

  window.__themeConsent = {
    apply: apply,
    sync: sync,
  };
})(window, document);
